import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/shopping`

export default (id, payload = {}) =>
  http.delete(`${api}/${id}`, payload)
